import React from 'react';
import './Concept.css';
import dec_img from '../../img/concept-bg.gif'
import { Link } from "react-scroll";

const Concept = () => {
    return (
        <div className="concept-wrap" id='concept'>
            <div className="container concept">
                <h2 className='concept-title colorful'>Idea and concept of this event</h2>
                <div className="concept-content">
                    <div className='concept-content_main'>
                        <img className="concept-img concept-item" src={dec_img} alt="" />
                        <div className='concept-text--block concept-item'>
                            <p className="concept-text p1">Welcome to the highly anticipated C#/.NET Global Summit, the ultimate gathering for passionate developers looking to elevate their skills.</p>
                            <p className="concept-text p1">Explore best practices, real-world use cases, and engage in insightful sessions and interactive discussions with industry-leading experts. Learn about asynchronous programming, LINQ, and the latest advanced frameworks. Gain valuable insights from experts on design patterns, performance optimization, and dependency injection.</p>
                            <p className="concept-text p1">Register now to propel your C#/.NET career forward. Join us for this transformative event and take your coding skills to the next level.</p>
                            {/* <p className="concept-text p1">Plus, we're hooking you up with certificates to show off your new skills and knowledge.</p>
                            <p className='concept-text concept-text--bold p1'>So, if you're serious about staying ahead of the curve with the latest AI tools in marketing, you gotta hit that button and join our community-driven conference. Let's make moves and level up our game together!</p>
                            <p className='concept-text concept-text--bold p1'>And don't forget about the certificates - we got you covered, fam!</p> */}
                            <Link
                                activeClass="active"
                                to='tickets'
                                spy={true}
                                smooth={true}
                                offset={-94}
                                className='concept-btn button'
                            >
                                Join
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Concept;